/**
 * Conversion helpers for fractional quantity (fabric) products.
 *
 * Shopify cart quantities are integers. We treat 1 cart unit = 0.1 m, so:
 *   1.5 m display  <->  15 cart units
 *
 * Exposed on window.FractionalQuantity so Liquid-emitted inline scripts and
 * the various theme JS files can all reach the same helpers without bundling.
 */
window.FractionalQuantity = (function () {
  const UNITS_PER_METRE = 10;

  function metresToUnits(metres) {
    const n = Number(metres);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n * UNITS_PER_METRE);
  }

  function unitsToMetres(units) {
    const n = Number(units);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n) / UNITS_PER_METRE;
  }

  function formatMetres(metres) {
    const value = unitsToMetres(metresToUnits(metres));
    const unit = value === 1 ? 'metre' : 'metres';
    return value.toFixed(1) + ' ' + unit;
  }

  function snapToStep(metres) {
    return unitsToMetres(metresToUnits(metres));
  }

  function formatRandsFromCents(cents) {
    const rands = (cents / 100).toFixed(2);
    return 'R ' + rands.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return {
    UNITS_PER_METRE,
    metresToUnits,
    unitsToMetres,
    formatMetres,
    snapToStep,
    formatRandsFromCents,
  };
})();

(function () {
  function update(input) {
    const subtotalEl = findSubtotalFor(input);
    if (!subtotalEl) return;
    const unitPriceCents = parseInt(subtotalEl.dataset.unitPriceCents, 10);
    if (!Number.isFinite(unitPriceCents)) return;
    const metres = window.FractionalQuantity.snapToStep(input.value);
    const units = window.FractionalQuantity.metresToUnits(metres);
    subtotalEl.textContent = window.FractionalQuantity.formatRandsFromCents(units * unitPriceCents);
  }

  function findSubtotalFor(input) {
    const scope = input.closest('product-info') || input.closest('section') || document;
    return scope.querySelector('[data-fractional-subtotal]');
  }

  function initAll() {
    document.querySelectorAll('[data-fractional-subtotal]').forEach((el) => {
      const scope = el.closest('product-info') || el.closest('section') || document;
      const input = scope.querySelector('input.quantity__input[data-fractional="true"]');
      if (input) update(input);
    });
  }

  document.addEventListener('input', (e) => {
    if (e.target.matches && e.target.matches('input.quantity__input[data-fractional="true"]')) update(e.target);
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('input.quantity__input[data-fractional="true"]')) update(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.FractionalSubtotal = { update, initAll };
})();
